import { get, remove, set } from 'unified-navigation-ui/js/utils/tempStorage';
export const NAVCONFIG_CACHE_TTL = 1000 * 60 * 60 * 24; // 24 hours
export const NAVCONFIG_STORAGE_KEY = 'hubspot_navconfigs';
export const isNavConfigStale = ({
  cacheTimestamp
}) => Date.now() - cacheTimestamp > NAVCONFIG_CACHE_TTL;
const getCachedNavConfigs = () => {
  try {
    return JSON.parse(get('hubspot_navconfigs') || '{}');
  } catch (e) {
    return {};
  }
};
const getConfigWithTimestamp = config => Object.assign({}, config, {
  cacheTimestamp: Date.now()
});
export const navConfigCache = {
  get: portalId => {
    const navConfigs = getCachedNavConfigs();
    return navConfigs[portalId] || null;
  },
  set: (portalId, config) => {
    const navConfigs = {
      [`${portalId}`]: getConfigWithTimestamp(config)
    };
    set(NAVCONFIG_STORAGE_KEY, JSON.stringify(navConfigs));
  },
  delete: () => {
    remove(NAVCONFIG_STORAGE_KEY);
  }
};